require('fslightbox');

(function () {
    if (typeof refreshFsLightbox === 'function') {
        let gallery = document.querySelectorAll('.wp-block-gallery');
        gallery.forEach((galleryItem) => {
            let images = galleryItem.querySelectorAll('img');
            let galleryId = 'gallery-' + (Math.random() + 1).toString(36).substring(7);

            images.forEach(image => {
                let src = image.getAttribute('data-full-url') || image.getAttribute('src');
                let href = document.createElement('a');
                href.setAttribute('href', src);
                href.setAttribute('data-fslightbox', galleryId);

                image.parentNode.insertBefore(href, image);
                href.appendChild(image);
            });
        });

        refreshFsLightbox();
    }
}());